import { handleActions } from 'redux-actions';

export default handleActions(
	{
		GET_COURSE_LIST_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_COURSE_INFO_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_MEMBER_COURSE_LIST_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		COURSE_SIGNUP_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		GET_COURSE_RECOMMEND_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),

		DEFAULT_COURSE_INFO: (state, action) => ({
			...state,
			...action.payload,
		}),
	},
	{
		memberCourse: {
			come: [],
			past: [],
		},
		list: {
			come: [],
			apply: [],
			past: [],
		},
		recommend: [],
		info: [],
		teacher: [],
		id: '',
		inputFlash: 0,
		inputLens: 0,
		inputSeries: 0,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/course.js